<template>
    <div>
        <v-container fluid class="primary py-0 hidden-sm-and-down" v-if="1==0">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="mb-4 black--text">
                            My Questions
                        </h1>
                    </v-col>
                </v-row>
                <!--                <v-btn rounded class="accent" style="margin-bottom: -20px" @click="addRecordDialog = true">-->
                <!--                    Add New Record-->
                <!--                    <v-icon right>mdi-arrow-right</v-icon>-->
                <!--                </v-btn>-->
            </v-container>
        </v-container>
        <v-container fluid :class="{'px-12': $vuetify.breakpoint.mdAndUp, 'pt-0': $vuetify.breakpoint.smAndDown}" class="mt-6">
            <v-row v-if="userInfo">
                <v-col cols="12" sm="12" md="7" class="hidden-md-and-up">
                    <h2>My Questions</h2>
                </v-col>
                <v-col cols="12" sm="12" md="7" class="pt-0">
                    <v-row class="hidden-sm-and-down">
                        <v-col cols="12" sm="12">
                            <v-card outlined>
                                <v-card-text>
                                    <v-row class="pb-0" dense>
                                        <v-col cols="12" sm="12" md="5" class="pb-0">
                                            <v-text-field label="Search" v-model="search" solo flat class="solo-bordered"
                                                          prepend-inner-icon="mdi-magnify"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-simple-table v-if="!loadingQuestions">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Title</th>
                                                <th class="text-left">Submitted On</th>
                                                <th class="text-left">Answers</th>
                                                <th class="text-left">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="question in questionList" :key="question.id"
                                                @click="getQuestionDetails(question.id)"
                                                :class="{'grey lighten-3' : questionDetails === question}"
                                                class="pointer">
                                                <td>
                                                    {{ question.title }}
                                                </td>
                                                <td>
                                                    {{ dateutils.utcToLocalDisplay(question.created_at) }}
                                                </td>
                                                <td>
                                                    {{ question.total_answers }}
                                                </td>
                                                <td>
                                                    <v-btn small outlined color="darkPrimary" class="mr-2"
                                                           @click="questionDetails = question">
                                                        View Details
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            <tr v-if="!questionList.length">
                                                <td colspan="5" class="text-center">
                                                    <div class="text-center my-6">
                                                        <v-icon large>mdi-alert</v-icon>
                                                        <br>
                                                        <h3 class="font-weight-regular">No Questions Found</h3>
                                                        <div class="mt-8 d-flex justify-center align-center">
                                                            <v-btn small outlined
                                                            @click="goToWebsite('ask-a-question/#ask', false)"
                                                                > Ask Question
                                                            </v-btn>                                                            
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <div v-if="loadingQuestions" class="py-12 text-center d-flex justify-center">
                                        <v-progress-circular
                                                :size="50"
                                                :width="5"
                                                color="primary"
                                                indeterminate
                                        ></v-progress-circular>
                                    </div>
                                    <v-pagination
                                            color="darkPrimary"
                                            @input="getQuestionList"
                                            v-model="page"
                                            :length="questionPaginationDetails.last_page"
                                            v-if="questionPaginationDetails.total > filters.limit"
                                    ></v-pagination>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!--                    Mobile List UI-->
                    <v-row class="hidden-md-and-up">
                        <v-col cols="12" class="pt-0">
                            <v-row class="pb-0" dense>
                                <v-col cols="12" sm="12" md="5" class="pb-0">
                                    <v-text-field hide-details label="Search" v-model="search" solo flat class="solo-bordered"
                                                  prepend-inner-icon="mdi-magnify"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <v-list three-line v-if="!loadingQuestions && questionList.length">
                                <v-list-item-group>
                                    <v-divider></v-divider>
                                    <template v-for="question in questionList">
                                        <v-list-item :key="question.id+'m'"
                                                     @click="showQuestionDetails(question.id)">
                                            <v-list-item-avatar color="grey lighten-2" tile>

                                                {{ dateutils.utcToLocal(question.created_at).format('DD') }}
                                                {{ dateutils.utcToLocal(question.created_at).format('MMM') }}
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ question.title}}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ dateutils.utcToLocal(question.created_at).format('dddd, hh:mm A') }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-action-text>
                                                    <v-icon>mdi-chevron-right</v-icon>
                                                </v-list-item-action-text>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="question.id"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                            <div v-if="!loadingQuestions && questionList.length" class="pt-3">
                                <v-pagination
                                        color="darkPrimary"
                                        @input="getQuestionList"
                                        v-model="page"
                                        :length="questionPaginationDetails.last_page"
                                        v-if="questionPaginationDetails.total > filters.limit"
                                ></v-pagination>
                            </div>
                            <div v-if="loadingQuestions" class="py-12 text-center">
                                <v-progress-circular
                                        :size="50"
                                        :width="5"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </div>
                            <div v-if="!questionList.length && !loadingQuestions" class="py-12 text-center">
                                <v-icon x-large>mdi-alert</v-icon>
                                <br>
                                <h3 class="font-weight-regular">No Questions Found</h3>
                                <div class="mt-8 d-flex justify-center align-center">
                                                            <v-btn small outlined
                                                            @click="goToWebsite('ask-a-question', false)"
                                                                > Ask Question
                                                            </v-btn>                                                            
                                                        </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <!--                Details-->
                <v-col cols="12" sm="12" md="5" class="lightPinkBackground hidden-sm-and-down">
                    <v-row>

                        <v-col cols="12" class="pt-0">
                            <question-details :question-details="questionDetails"
                                              v-if="Object.keys(questionDetails).length"></question-details>
                            <v-card style="" flat tile class="mb-4" v-else>

                                <v-card-text class="text-center">
                                    <v-icon x-large>mdi-alert</v-icon>
                                    <br>
                                    <h3 class="font-weight-regular">No Records Found</h3>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" sm="12" class="text-center">
                    <h1>
                        Please login to continue to your Dashboard
                    </h1>
                    <br>
                    <v-btn class="accent-gradient white--text" large @click="goToWebsite('patient-login', false)">
                        Login
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog 
            :key="questionDetails.id"
            v-model="sheet"
            fullscreen
            :class="white"            

         >
         <div class="white" style="height:100%">
             <v-toolbar
                    dark          
                    color="primary"
                >
                <v-btn
                    icon
                    dark
                    color="black"
                    @click="sheet = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="black--text"></v-toolbar-title>
                <v-spacer></v-spacer>
            
            </v-toolbar>

            <question-details :key="questionDetails.id" :question-details="questionDetails" class="white"></question-details>
         </div>
            
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionDetails from "../components/QuestionDetails";

    export default {
        name: "MyQuestions",
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        components: {
            QuestionDetails
        },
        mounted() {
            if(this.$route.params.id){             
                this.showDetail =true
                this.filter = '';
                this.getQuestionList()
                .then(()=>{                                                
                    this.getQuestionDetails(this.$route.params.id)                
                })
                
            }
            else{
                this.getQuestionList();
            }
            
        },
        methods: {
            showQuestionDetails(question_id) {
                this.getQuestionDetails(question_id).then(()=>{
                        this.sheet = true;
                })                
                
            },
            getQuestionDetails(question_id) {
                const request = this.axios.get(`${process.env.VUE_APP_API_URL}/api/questions/${question_id}`)
                    return request.then(`${process.env.VUE_APP_API_URL}/api/questions/${question_id}`)
                    .then((response) => {
                        this.questionDetails = response.data.data;
                        this.showDetail = true
                        return response
                    }).catch((error) => {
                    console.log(error);
                });
            },
            getQuestionList: function () {
                if (!this.userInfo) {
                    return;
                }
                this.questionList = []
                this.loadingQuestions = true;
                this.filters.page = this.page;
                this.filters.patient_id = this.userInfo.id;
                this.filters.title = this.search;
                return new Promise((resolve) => {
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/questions`, {
                        params: this.filters
                    }).then((response) => {
                        if (response.data.status === 1) {
                            this.questionPaginationDetails = response.data.data;
                            this.questionList = this.questionPaginationDetails.data;


                            if (this.questionList.length && !this.showDetail) {
                                this.questionDetails = this.questionList[0];
                                this.getQuestionDetails(this.questionDetails.id)
                            }
                        }
                        this.loadingQuestions = false;
                    }).catch((error) => {
                        console.log(error);
                        this.loadingQuestions = false;
                    }).finally(() => {                      
                        resolve()
                    })
                })
                
            },
            resetParams(){
                this.page = 1
            }

        },
        data: () => ({
            sheet: false,
            addRecordDialog: false,
            uploadSucess: false,
            saveLoading: false,
            filters: {
                format_type: 'paginate',
                limit: 6
            },
            questionPaginationDetails: {},
            page: 1,
            loadingQuestions: false,
            questionList: [],
            questionDetails: {},
            selectedAppointment: {
                doctor: {
                    name: null
                }
            },
            search:"",
            showDetail:false
        }),
        watch:{
            search(){
                this.resetParams()
                this.getQuestionList()
            }
        }
    }
</script>

<style>
    .banner-cards {
        border: 1px solid #e9c68e !important;
    }

    .banner-cards .card__actions {
        padding: 4px 8px !important;
    }

    .solo-bordered .v-input__slot {
        border: 1px solid #ccc;
    }
</style>